import { Component, OnInit, Inject, forwardRef } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'back-jacket',
  templateUrl: './back-jacket.component.html',
  styleUrls: ['./back-jacket.component.css']
})
export class BackJacketComponent implements OnInit {

  constructor(@Inject(forwardRef(() => AppComponent)) public parent : AppComponent) { }


  ngOnInit() {
      this.parent.applyDesignOnJacket();
  }

}



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/back-jacket/back-jacket.component.ts